export const getUserName = (user) => {
  return user ? `${user.firstName} ${user.lastName}` : '';
}